"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTextTexture = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
/*
 * Creates a text sprite
 */
function createTextTexture(options) {
    var _a, _b, _c, _d, _e, _f, _g;
    var canvas = document.createElement("canvas");
    canvas.width = (_a = options.canvasSize) !== null && _a !== void 0 ? _a : 256;
    canvas.height = (_b = options.canvasSize) !== null && _b !== void 0 ? _b : 256;
    var ctx = canvas.getContext("2d");
    // Set options
    var fontSize = (_c = options.fontSize) !== null && _c !== void 0 ? _c : 24;
    ctx.font = "".concat((_d = options.fontWeight) !== null && _d !== void 0 ? _d : 500, " ").concat(fontSize, "px ").concat((_e = options.fontFamily) !== null && _e !== void 0 ? _e : "sans-serif");
    var textWidth = ctx.measureText(options.text).width;
    ctx.fillStyle = (_f = options.backgroundColor) !== null && _f !== void 0 ? _f : "rgba(255, 255, 255, 0)";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = (_g = options.color) !== null && _g !== void 0 ? _g : "white";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(options.text, canvas.width * 0.5, canvas.height * 0.5);
    var texture = new realms_three_1.default.CanvasTexture(canvas);
    return { texture: texture, textWidth: textWidth, fontSize: fontSize };
}
exports.createTextTexture = createTextTexture;
